import ApolloClient from '@/packages/apollo-client'
import { executeSimpleQuery } from '@/store/helpers/apollo'

import FetchLogs from './Schema/Queries/FetchLogs.gql'
import FetchReturningPartReasons from './Schema/Queries/FetchReturningPartReasons.gql'



import {
	FETCH_LOGS,
	FETCH_RETURNING_PART_REASONS

} from './action-types'

import {
	SET_RETURNING_PART_REASONS
} from './mutation-types'


let returningPartReasonsRequest = null

export default {
	async [FETCH_LOGS] (_, payload) {
		const query = {
			query: FetchLogs,
			fetchPolicy: 'no-cache',
			variables: {
				payload
			}
		}

		try {
			const { data } = await ApolloClient.query(query)

			if (data.errors) {
				return Promise.reject(data.errors)
			}
			return data?.logs?.nodes
		} catch (e) {
			return  Promise.reject(e)
		}
	},

	async [FETCH_RETURNING_PART_REASONS] ({ commit, state }) {
		if (state.returningPartReasons.length) {
			return state.returningPartReasons
		}

		if (!returningPartReasonsRequest) {
			returningPartReasonsRequest = executeSimpleQuery({
				query: FetchReturningPartReasons
			}).then(data => data?.returningPartReasons?.reasons || [])
				.finally(() => {
					returningPartReasonsRequest = null
				})
		}

		const reasons = await returningPartReasonsRequest
		commit(SET_RETURNING_PART_REASONS, reasons)
		return reasons
	}
}
